// Generic helper
import * as util from '../view-advice-util'
import * as immu from 'object-path-immutable'

// -----------------------------------
// Recommendation Text Generation
// -----------------------------------

// Default
export default createPredict
// Named export
export function createPredict( dict, items, lang ) {

  // Between each medikation newline
  // const distance = "<br><span style='display:block;height:.5rem'></span>"
  const distance = "" //<span style='display:block;height:.5rem'></span>"

  // Possible loading not completed in drugs
  if ( items.some( item => !item.rule ) ) {
    return dict[ "berechnung" ]
  }

  // Replace text with real drugs
  const redu = util.replaceDrugs( dict.place1, dict.place2, lang )
  const rest = util.replaceDrugs( dict.place2, dict.place3, lang )
  // Map of drug nams
  const names = items.reduce( ( acc, cur ) => {
    return immu.set( acc, cur.rule.drug, cur.name )
  }, {} )

  const texte = []

  // One drug no detection possible
  if ( items.length == 1 ) {
    texte.push( redu( items[ 0 ][ "name" ], dict.emp_na ) )
    // @TODO add you can add more
    return texte.join( " " )
  }

  // Prediction failed or missing
  const fail = items.filter( item => !item.rule.predict )
  const pred = items.filter( item => !!item.rule.predict ).sort( ( a, b ) => {
    if ( !b.rule.predict.auc_ratio || !a.rule.predict.auc_ratio ) {
      return 0
    }
    return b.rule.predict.auc_ratio - a.rule.predict.auc_ratio
  } )

  // Add general empfehlung sentence
  texte.push( dict.emp_intro )
  texte.push( distance )

  // -------------------------------------------------
  // Pre2: Valid prediction iterate per substance
  // span.over will be extracted in overview
  // -------------------------------------------------
  const drugKeys = {}
  // invalid interactors
  const invalidInteractors = pred.reduce( ( acc, cur ) => {
    for ( const failure in cur.rule.predict.failure ) {
      if ( acc.indexOf( names[ failure ] ) > -1 ) continue
      const message = cur.rule.predict.failure[ failure ].message
      if ( message.indexOf( 'invalid_interactor' ) > -1 ) {
        acc.push( names[ failure ] )
      }
    }
    return acc
  }, [] )
  for ( const item of pred ) {
    // Shorter reference
    const ref = item.rule.predict
    // Last item
    const last = pred.indexOf( item ) + 1 == pred.length

    drugKeys[ item.name ] = [ ref.status ]


    // Success quantitative
    if ( ref.status === 'success_quant' ) {
      // Handle no changes separately
      if ( ref.auc_ratio == 1 ) {
        drugKeys[ item.name ].push( 'emp_pre2st' )
      } else {
        successQuant( items, item, dict, lang, texte )
      }
    }
    // Success quantitative
    else if ( ref.status === 'success_quali' ) {
      successQuali( item, drugKeys )
    }
    // Failure unclear
    else if ( ref.status === 'failure_uncle' ) {
      failureUnclear( item, drugKeys )
    }
    // Failure substrate with invalid pathways
    else if ( ref.status === 'failure_inval' ) {
      failureInvalid( item, drugKeys )
    } // Failure due to metamizol interactor
    else if ( ref.status === 'failure_metamizol' ) {
      failureMetamizol( item, drugKeys )
    }

    // CONSEQUENCES
    const pro = item.rule.param.some( line => line.includes( "parent inactive" ) )
    const nti = item.rule.param.some( line => line.includes( "nti true" ) )
    if ( ( ref.net_effect == "+" || ref.net_effect == "++" ) & ref.status == 'success_quali' ) {
      // Check for prodrug
      if ( pro ) {
        drugKeys[ item.name ].push( 'emp_sucuppro' )
      }
      // No prodrug and likely more problems
      else {
        // Emphasize nti
        if ( nti ) {
          drugKeys[ item.name ].push( 'emp_sucup_nti' )
          // Check for monitoring options
          if ( item.rule.param.some( line => line.includes( "monitor ptt" ) ) ) {
            drugKeys[ item.name ].push( 'emp_sucup_nti_ptt' )
          } else if ( item.rule.param.some( line => line.includes( "monitor tdm" ) ) ) {
            drugKeys[ item.name ].push( 'emp_sucup_nti_tdm' )
          } else if ( item.rule.param.some( line => line.includes( "monitor tsh" ) ) ) {
            drugKeys[ item.name ].push( 'emp_sucup_nti_tsh' )
          } else if ( item.rule.param.some( line => line.includes( "monitor afxa" ) ) ) {
            drugKeys[ item.name ].push( 'emp_sucup_nti_afxa' )
          } else if ( item.rule.param.some( line => line.includes( "monitor afiia" ) ) ) {
            drugKeys[ item.name ].push( 'emp_sucup_nti_afiia' )
          } else {
            drugKeys[ item.name ].push( 'emp_sucup_nti_na' )
          }
        }
        // More adverse events in general
        else {
          drugKeys[ item.name ].push( 'emp_sucup' )
        }
      }
    }
    if ( ( ref.net_effect == "-" || ref.net_effect == "--" ) & ref.status == 'success_quali' ) {
      if ( pro ) {
        drugKeys[ item.name ].push( 'emp_sucdopro' )
      } else {
        drugKeys[ item.name ].push( 'emp_sucdo' )
      }
    }
  }
  const groups = {}
  for ( const name in drugKeys ) {
    if ( drugKeys[ name ].length < 2 ) {
      continue
    }
    const group = drugKeys[ name ].join( '#' )
    if ( typeof groups[ group ] === 'undefined' ) {
      groups[ group ] = {
        'names': [],
        'keys': drugKeys[ name ].slice( 1 )
      }
    }
    groups[ group ][ 'names' ].push( name )
  }
  for ( const group in groups ) {
    for ( const key of groups[ group ][ 'keys' ] ) {
      var text = dict[ key ]
      if ( typeof text == 'undefined' ) {
        text = groups[ group ][ 'names' ].length > 1 ? dict[ `${key}_p` ] : dict[ `${key}_s` ]
      }
      texte.push( redu( groups[ group ][ 'names' ], text ) )
    }
  }

  if ( Object.keys( names ).length > 2 && typeof ( names[ "metamizol" ] ) !== "undefined" ) {
    texte.push( dict[ 'emp_pre2_metamizol' ] )
  }

  // ---------------------------------------
  // Pre1 for all: Rather at the end the problems
  // ---------------------------------------
  if ( fail.length ) {
    // Distance previous text
    // if ( texte.length ) texte.push( "<br>" )
    // All together
    const names = fail.map( item => item.name )
    texte.push( redu( names, dict.emp_pre1s, dict.emp_pre1p ) )
  }

  // Text for invalid interactors
  if ( invalidInteractors.length > 0 ) {
    texte.push( redu( invalidInteractors, dict.emp_pre2_invalid_interactor_s, dict.emp_pre2_invalid_interactor_p ) )
  }

  return texte.join( " " )

}

function successQuant( items, item, dict, lang, texte ) {
  // Shorter reference
  const ref = item.rule.predict

  // Replace text with real drugs
  const redu = util.replaceDrugs( dict.place1, dict.place2, lang )
  const rest = util.replaceDrugs( dict.place2, dict.place3, lang )
  // Map of drug nams
  const names = items.reduce( ( acc, cur ) => {
    return immu.set( acc, cur.rule.drug, cur.name )
  }, {} )

  // Start with Die Exposition [<b> AUC </b>] von Simvastatin verändert sich nicht
  var pre2 = dict.emp_pre2na

  // PREDICTION
  if ( ref.auc_ratio > 1 ) {
    const percent = ( ref.auc_ratio * 100 ).toFixed( 0 )
    pre2 = dict.emp_pre2up.replace( "110%", `<b class=r>${percent}%</b>` )
  } else if ( ref.auc_ratio < 1 && ref.auc_ratio > 0 ) {
    const percent = ( ref.auc_ratio * 100 ).toFixed( 0 )
    pre2 = dict.emp_pre2do.replace( "80%", `<b class=r>${percent}%</b>` )
  }

  const relInt = ref.auc_interval && ref.auc_interval.length > 1 ? ref.auc_interval.some( val => {
    return val > 1.5 || val < 0.7
  } ) : false
  // Also used way below
  // Fix ciclosporin 1.34 [1,10] & apixaban
  const relevant = ref.auc_ratio && ( ref.auc_ratio > 1.5 || ref.auc_ratio < 0.7 || relInt )
  // Start sentence or stop and replace the above
  if ( Object.keys( ref.success ).length ) {
    if ( relevant ) {
      texte.push( `<span class=over>${redu( item.name, pre2 )}</span>` )
    } else {
      texte.push( redu( item.name, pre2 ) )
    }
  } else {
    texte.push( redu( item.name, pre2 ).replace( /,$/, "." ) )
  }

  // -----------------------------------------------------------
  // SUCCESS
  // -----------------------------------------------------------
  // HALF SENTENCE is the same for all options
  if ( Object.keys( ref.success ).length ) {
    // Prepare opfer sentence
    // Create colored labels with separated influence only for drugs e.g. Pravastatin (70%)
    // Spans necessary not to replace e.g. Clarithromycin twice Clarithromycin(100%) (100%)
    var labels = Object.keys( ref.success ).filter( key => !key.includes( "CYP" ) ).map( key => {
      const valu = ( ref.success[ key ][ "auc_ratio" ] * 100 ).toFixed( 0 )
      const name = names[ key ]

      if ( valu == 100 ) {
        return ''
        //return `<span>${name}</span> (<span>${valu}%</span>)`
      }
      // used to be <b class=r>
      return `<span>${name}</span> (<span>${valu}%</span>)`
    } ).filter( label => label != '' )
    if ( labels.length == 0 ) {
      var lastSentence = texte.pop()
      texte.push( lastSentence.replace( /,$/, "." ) )
    }
    // wenn eine Kombination mit Terbinafin (469%) kombiniert wird.
    var medis = rest( labels, dict.emp_pre2fi1, dict.emp_pre2fi2 )
    /// Add Metabolizer status if available
    // "CYP2D6*PM": {
    //   "auc_ratio": 4.84,
    //   "message": "cyp2d6",
    //   "ignored": ""
    // }
    var metas = Object.keys( ref.success ).filter( key => {
      return key.includes( "CYP" ) && key.includes( ref.success[ key ][ "message" ].toUpperCase() )
    } )
    if ( metas.length > 0 ) {
      var cyps = dict.emp_genometa.replace( "CYP9X99", metas.map( key => {
        const ratio = ( ref.success[ key ][ "auc_ratio" ] * 100 ).toFixed( 0 )
        return `<b class=r>${key}</b> (${ratio}%)`
      } ).join( ", " ) )
      medis = medis.replace( /.$/, " " + cyps )
    }
    if ( relevant ) {
      texte.push( `<span class=over>${medis}</span>` )
    } else {
      texte.push( medis )
    }
  }

  // -------------------------------------------------------------
  // ADD Genotype interval info
  // Exclude interval for now if now auc_ratio
  // -------------------------------------------------------------
  if ( ref.auc_ratio && ref.auc_interval.length > 1 ) {
    const link = `<unit-link label="${dict.emp_genoplace}" value="/clinic/findings/${lang}/" class="router cytochrome"></unit-link>`
    // Insert link for questions of genotyp
    var genotyp = dict.emp_genorange.replace( dict.emp_genoplace, link )
    // Add relevant genotypes for interval which are not considered yet
    const factors = Object.keys( ref.auc_factor ).filter( key => {
      return !ref.auc_factor[ key ] && /cyp/i.test( key )
    } )
    // If relevant factors left
    if ( factors.length > 0 ) {
      genotyp = genotyp.replace( "CYP9X99", factors.join( ", " ).toUpperCase() )
      // Add specific values
      const min = ( ref.auc_interval[ 0 ] * 100 ).toFixed( 0 )
      genotyp = genotyp.replace( " 0%", ` <b class=r>${min}%</b>` )
      const max = ( ref.auc_interval[ 1 ] * 100 ).toFixed( 0 )
      genotyp = genotyp.replace( " 100%", ` <b class=r>${max}%</b>` )
      if ( relevant ) {
        texte.push( `<span class=over>${genotyp}</span>` )
      } else {
        texte.push( genotyp )
      }
    }
  }

  // CONSEQUENCES
  const pro = item.rule.param.some( line => line.includes( "parent inactive" ) )
  const nti = item.rule.param.some( line => line.includes( "nti true" ) )
  if ( ( ref.net_effect == "+" || ref.net_effect == "++" ) & ref.status.indexOf( 'success' ) > -1 ) {
    // Check for prodrug
    if ( pro ) {
      texte.push( redu( item.name, dict.emp_sucuppro ) )
    }
    // No prodrug and likely more problems
    else {
      // Emphasize nti
      if ( nti ) {
        texte.push( redu( item.name, dict.emp_sucup_nti ) )
        // Check for monitoring options
        if ( item.rule.param.some( line => line.includes( "monitor ptt" ) ) ) {
          texte.push( redu( item.name, dict.emp_sucup_nti_ptt ) )
        } else if ( item.rule.param.some( line => line.includes( "monitor tdm" ) ) ) {
          texte.push( redu( item.name, dict.emp_sucup_nti_tdm ) )
        } else if ( item.rule.param.some( line => line.includes( "monitor tsh" ) ) ) {
          texte.push( redu( item.name, dict.emp_sucup_nti_tsh ) )
        } else if ( item.rule.param.some( line => line.includes( "monitor afxa" ) ) ) {
          texte.push( redu( item.name, dict.emp_sucup_nti_afxa ) )
        } else if ( item.rule.param.some( line => line.includes( "monitor afiia" ) ) ) {
          texte.push( redu( item.name, dict.emp_sucup_nti_afiia ) )
        } else {
          texte.push( redu( item.name, dict.emp_sucup_nti_na ) )
        }
      }
      // More adverse events in general
      else {
        texte.push( redu( item.name, dict.emp_sucup ) )
      }
    }
  }
  if ( ( ref.net_effect == "-" || ref.net_effect == "--" ) & ref.status.indexOf( 'success' ) > -1 ) {
    if ( pro ) {
      texte.push( redu( item.name, dict.emp_sucdopro ) )
    } else {
      texte.push( redu( item.name, dict.emp_sucdo ) )
    }
  }
}

function successQuali( item, drugKeys ) {
  // Shorter reference
  const ref = item.rule.predict

  // PREDICTION
  if ( ref.net_effect == "++" ) {
    drugKeys[ item.name ].push( 'emp_pre2up2_est' )
  } else if ( ref.net_effect == "+" ) {
    drugKeys[ item.name ].push( 'emp_pre2up1_est' )
  } else if ( ref.net_effect == "≈" ) {
    drugKeys[ item.name ].push( 'emp_pre2up0_est' )
  } else if ( ref.net_effect == "--" ) {
    drugKeys[ item.name ].push( 'emp_pre2do2_est' )
  } else if ( ref.net_effect == "-" ) {
    drugKeys[ item.name ].push( 'emp_pre2do1_est' )
  }
}

function failureUnclear( item, drugKeys ) {
  drugKeys[ item.name ].push( 'emp_pre2_unclear' )
}

function failureInvalid( item, drugKeys ) {
  drugKeys[ item.name ].push( 'emp_pre2_invalid' )
}

function failureMetamizol( item, drugKeys ) {
  drugKeys[ item.name ].push( 'emp_pre2_metamizol' )
}